module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ctn-operation-form take-place"
  }, [_c('div', {
    staticClass: "white-box row title"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'InvestmentsManual',
        params: _vm.isCgpi ? {
          clientId: _vm.client.id
        } : {
          kind: 'client'
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), (this.$route.params.id) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\tModifier le produit\n\t\t")]) : _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\tAjouter un produit\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box"
  }, [_c('edit-main', {
    attrs: {
      "client-id": _vm.client ? _vm.client.id : null,
      "investmentProduct": _vm.investmentProduct,
      "kind": _vm.kind
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b35ce842"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/InvestmentsManual/InvestmentsManualForm.vue
// module id = 1167
// module chunks = 0